import { useEffect, useState } from 'react'

type Parameters = {
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
}

type Props = {
  children: ({ isExpanded, setIsExpanded }: Parameters) => void
  initial: boolean
}

const Toggle = ({ children, initial = false }: Props) => {
  const [isExpanded, setIsExpanded] = useState(initial)

  useEffect(() => {
    setIsExpanded(initial)
  }, [initial])

  return <>{children({ isExpanded, setIsExpanded })}</>
}

export default Toggle
